module.exports = __webpack_public_path__ + "img/scout_&_nimble_mobile.6405a11.png";